import React from 'react'
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import "../ContentSeo/TitleDivSeo.css";
import Table from 'react-bootstrap/Table';
// import 'bootstrap/dist/css/bootstrap.min.css';
function DataInformationAboutIp(props) {


  return (
    <div  id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo'>
      <br /><br />
        <h3 style={{color:"#999999",textAlign:"right"}}>التكنولجيات</h3>
       <hr />
       <br />
      <div className="CARD">
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>عنوان الخادم ال IP</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        {/* <Typography fontWeight="md" textColor="success.plainColor"> */}
        <Table style={{textAlign:"center"}} striped bordered hover>
      <thead >
        <tr style={{border:"1px solid gray"}}>
          <th style={{border:"1px solid gray"}}>عنوان ال IP</th>
          <th style={{border:"1px solid gray"}}>موقع الخادم</th>
          <th style={{border:"1px solid gray"}}>مقدم الخدمة</th>
        </tr>
      </thead>
      <tbody>
        <tr style={{border:"1px solid gray"}}>
          <td style={{border:"1px solid gray"}}>{props.websiteInfoIp ? props.websiteInfoIp : "Not Available" }</td>
          <td style={{border:"1px solid gray"}}>{props.websiteInfoCountry ? props.websiteInfoCountry  : "Not Available" }</td>
          <td style={{border:"1px solid gray"}}>{props.websiteInfoOrganization ? props.websiteInfoOrganization :"Not Available" }</td>
        </tr>
      </tbody>
    </Table>
        {/* </Typography> */}

</CardContent>
    </Card>
    </div>
    </div>
    </div>
  )
}
export default DataInformationAboutIp